import React from 'react';
import PropTypes from 'prop-types';
import { GenericCollection, JSONLD } from 'react-structured-data';
import { ItemList, ListItem } from './MicrodataComponents';

const createItemListElements = (products, hostname) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <GenericCollection type="itemListElement">
      {products.map(({ url }, idx) => (
        <ListItem url={`https://${hostname}${url}`} position={idx + 1} key={`microdata-itemList-${url}`} />
      ))}
    </GenericCollection>
  );
};

const ProductListMicrodata = ({ products, path, hostname, numberOfItems }) => {
  if (numberOfItems === 0) {
    return null;
  }

  return (
    <JSONLD dangerouslyExposeHtml>
      <ItemList numberOfItems={numberOfItems}>{createItemListElements(products, hostname)}</ItemList>
    </JSONLD>
  );
};

ProductListMicrodata.propTypes = {
  path: PropTypes.string.isRequired,
  hostname: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ProductListMicrodata;
